import axios from "axios";

function httpClient(baseURL) {
  const baseClient = axios.create({
    baseURL,
    timeout: 60000,
  });

  baseClient.interceptors.request.use(async (request) => {
    const authData = localStorage.getItem("auth");
    const parsed = authData ? JSON.parse(authData) : null;
    const accessToken = parsed?.tokens?.accessToken;
    if (!accessToken) window.location.href = "/";
    return {
      ...request,
      headers: {
        ...request.headers,
        Authorization: `Bearer ${accessToken}`,
      },
    };
  });

  // RESPONSE INTERCEPTOR
  baseClient.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        window.location.href = "/";
      }
      return Promise.reject(error);
    }
  );

  return baseClient;
}

export const client = httpClient(process.env.REACT_APP_API_URL);
